import { useState } from "react";
import { useApiClient } from "../../auth/useApiClient";

export function usePdfDownload(): {
  downloading: boolean;
  downloadPdf: (poId: string, poNumber: string) => Promise<void>;
  error: string | null;
} {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { get } = useApiClient();

  async function downloadPdf(poId: string, poNumber: string): Promise<void> {
    setDownloading(true);
    setError(null);
    try {
      const response = await get(`/api/pos/${poId}/pdf`);
      const contentType = response.headers.get("Content-Type") ?? "";

      let blob: Blob;

      if (contentType.includes("application/json")) {
        // Approved PDF: server returns a SAS URL — fetch the blob directly
        const body = await response.json() as { success: boolean; data: { url: string } };
        if (!body.success) throw new Error("Failed to get PDF URL");
        const blobResponse = await fetch(body.data.url);
        if (!blobResponse.ok) throw new Error("Failed to download PDF from storage");
        blob = await blobResponse.blob();
      } else {
        // Draft PDF: server streams the PDF directly
        blob = await response.blob();
      }

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${poNumber}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch {
      setError("Failed to download PDF. Please try again.");
    } finally {
      setDownloading(false);
    }
  }

  return { downloading, downloadPdf, error };
}
